
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pogoda",
      function () {
        return require("private-next-pages/[region]/[resort]/pogoda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pogoda"])
      });
    }
  